import { render, staticRenderFns } from "./averageWageColumnsList.vue?vue&type=template&id=56c4b4a0&"
import script from "./averageWageColumnsList.vue?vue&type=script&lang=js&"
export * from "./averageWageColumnsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports